import { useCallback, useState } from 'react';

interface UseEntitySelectionDialogOptions<TEntity> {
  onEntitiesSelected?: (entities: TEntity[]) => void;
  closeOnSelect?: boolean; // Default: true
  onOpen?: () => void;
  onClose?: () => void;
}

function useEntitySelectionDialog<TEntity>(
  options: UseEntitySelectionDialogOptions<TEntity> = {},
) {
  const {
    onEntitiesSelected,
    closeOnSelect = true,
    onOpen,
    onClose,
  } = options;

  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
    onOpen?.();
  }, [onOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  const handleEntitiesSelect = useCallback((entities: TEntity[]) => {
    onEntitiesSelected?.(entities);
    if (closeOnSelect) {
      close();
    }
  }, [onEntitiesSelected, closeOnSelect, close]);

  return {
    isOpen,
    open,
    close,
    handleEntitiesSelect,
  };
}

export { useEntitySelectionDialog, type UseEntitySelectionDialogOptions };
